let cachedBrowserInfo: { name: string; version: string } | null = null;

export const getBrowserInfo = (): { name: string; version: string } => {
  if (cachedBrowserInfo) {
    return cachedBrowserInfo;
  }

  try {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown";
    let version = "";

    if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Firefox";
      version = userAgent.match(/Firefox\/([0-9.]+)/)?.[1] || "";
    } else if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
      version = userAgent.match(/Chrome\/([0-9.]+)/)?.[1] || "";
    } else if (userAgent.indexOf("Safari") > -1) {
      browserName = "Safari";
      version = userAgent.match(/Version\/([0-9.]+)/)?.[1] || "";
    } else if (userAgent.indexOf("Edge") > -1) {
      browserName = "Edge";
      version = userAgent.match(/Edge\/([0-9.]+)/)?.[1] || "";
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident/") > -1) {
      browserName = "Internet Explorer";
      version = userAgent.match(/(?:MSIE |rv:)([0-9.]+)/)?.[1] || "";
    }

    cachedBrowserInfo = { name: browserName, version };
    return cachedBrowserInfo;
  } catch (error) {
    console.warn("Failed to detect browser info:", error);
    return { name: "unknown", version: "" };
  }
};
